import { Formik, Form, Field } from "formik"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { t, tError } from "../../i18next"
import { AppLogo, GaraioLogo } from "../common"
import * as actions from "./redux/actions"

export class LoginPage extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      keyboardVisible: false,
    }
  }
  handleSoftKeyboardVisible = () => {
    if (navigator.userAgent.indexOf("iPad") !== -1) this.setState({ keyboardVisible: true })
  }

  handleSoftKeyboardInvisible = () => {
    if (navigator.userAgent.indexOf("iPad") !== -1) this.setState({ keyboardVisible: false })
    this.setState({ keyboardVisible: false })
  }

  handleSubmit = formValues => {
    this.hideKeyboard()
    this.props.actions.login(formValues)
  }

  hideKeyboard() {
    for (const input of document.getElementsByTagName("input")) input.blur()
  }

  render() {
    const { auth, actions } = this.props
    return (
      <div className={this.state.keyboardVisible ? "auth-login-page keyboard" : "auth-login-page"}>
        <div className="spacer-top" />

        <div className="logos">
          <GaraioLogo />
          <AppLogo />
        </div>

        <h1 className="title">FACILITY APP</h1>

        <Formik
          initialValues={{ username: "", password: "" }}
          onSubmit={this.handleSubmit}
          render={_formikBag => (
            <Form className="form login-form">
              <Field
                name="username"
                render={({ field }) => (
                  <input
                    {...field}
                    id="username"
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    placeholder={t("auth.username")}
                    onFocus={this.handleSoftKeyboardVisible}
                    onBlur={this.handleSoftKeyboardInvisible}
                    disabled={auth.loginPending}
                  />
                )}
              />

              <Field
                name="password"
                render={({ field }) => (
                  <input
                    {...field}
                    id="password"
                    type="password"
                    placeholder={t("auth.password")}
                    onFocus={this.handleSoftKeyboardVisible}
                    onBlur={this.handleSoftKeyboardInvisible}
                    disabled={auth.loginPending}
                  />
                )}
              />

              <div className="message-area">
                {auth.loginPending && (
                  <div className="message login-pending">
                    <div className="text">{t("auth.working")}</div>
                  </div>
                )}
                {!isEmpty(auth.loginError) && (
                  <div className="message login-error">
                    <div className="text">{tError("auth", auth.loginError)}</div>
                    <span className="dismiss" onClick={actions.dismissLoginError}>
                      &times;
                    </span>
                  </div>
                )}
              </div>

              <button className="btn login-btn" type="submit" disabled={auth.loginPending}>
                {t("auth.login")}
              </button>
            </Form>
          )}
        />

        <div className="spacer-bottom">
          <div className="version-info">v{process.env.NPM_VERSION}</div>
        </div>
      </div>
    )
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    auth: state.auth,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPage)



// WEBPACK FOOTER //
// ./src/features/auth/LoginPage.js